export const complaintFilterOptions = [
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
  {
    name: "Supervisor",
    value: [["supervisor", "id"]],
    label: [["supervisor", "fullName"]],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
  {
    name: "Visit Status",
    optionsList: [
      {
        value: 1,
        label: "Visited",
        color: "text-green",
      },
      {
        value: 0,
        label: "Not Visited",
        color: "text-yellow-500",
      },
    ],
    valueAddress: [["isVisited"]],
    isStatic: true,
    unsort: true,
  },
];

export const VisitFilterOptions = [
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
  {
    name: "Supervisor",
    value: [["supervisor", "id"]],
    label: [["supervisor", "fullName"]],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
  {
    name: "Status",
    optionsList: [
      {
        value: 1,
        label: "Approved",
        color: "text-green",
      },
      {
        value: 0,
        label: "Pending",
        color: "text-yellow-500",
      },
      {
        value: -1,
        label: "Rejected",
        color: "text-red-1",
      },
    ],
    valueAddress: [["status"]],
    isStatic: true,
    unsort: true,
  },
];

export const VisityPendingFilterOptions = [
  {
    name: "Field Technician",
    value: [["fieldTechnician", "id"]],
    label: [["fieldTechnician", "fullName"]],
  },
  {
    name: "Supervisor",
    value: [["supervisor", "id"]],
    label: [["supervisor", "fullName"]],
  },
  {
    name: "category",
    value: [["category", "id"]],
    label: [["category", "name"]],
  },
];

export const COMPLAINT_SEARCH_OPTIONS = {
  siteId: ["station", "id"],
  site: ["station", "name"],
  fieldTechnician: ["fieldTechnician", "fullName"],
  category: ["category", "name"],
  description: ["description"],
};

export const siteCylinderChangeFilteroptions = [
  {
    name: "FT",
    value: [["fieldTechnicianID"]],
    label: [["fieldTechnicianName"]],
  },
  {
    name: "Supervisor",
    value: [["supervisorID"]],
    label: [["supervisorName"]],
  },
];

export const VEHICLE_READING_SEARCH_OPTIONS = {
  vehicle: ["vehicleNumber"],
  createdBy: ["createdBy", "fullName"],
};
export const VEHICLE_PENDING_READING_FILTERS_OPTIONS = [
  {
    name: "Field Technician",
    value: [["createdBy", "id"]],
    label: [["createdBy", "fullName"]],
  },
];

export const VEHICLE_READING_FILTERS_OPTIONS = [
  ...VEHICLE_PENDING_READING_FILTERS_OPTIONS,
  {
    name: "Status",
    optionsList: [
      {
        value: 1,
        label: "Approved",
        color: "text-green",
      },
      {
        value: 0,
        label: "Pending",
        color: "text-yellow-500",
      },
      {
        value: -1,
        label: "Rejected",
        color: "text-red-1",
      },
    ],
    valueAddress: [["status"]],
    isStatic: true,
    unsort: true,
  },
];
